import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/about-us',
      name: 'about',
      component: () => import('../views/AboutView.vue')
    },
    {
      path: '/solutions',
      name: 'solutions',
      component: () => import('../views/SolutionsView.vue')
    },
    {
      path: '/get-in-touch',
      name: 'contact',
      component: () => import('../views/ContactView.vue')
    },
    {
      path: '/work-with-us',
      name: 'work-with-us',
      component: () => import('../views/WorkWithUsView.vue')
    },
    {
      path: '/privacy-policy',
      name: 'privacy',
      component: () => import('../views/PrivacyView.vue')
    },
    {
      path: '/cookie-policy',
      name: 'cookies',
      component: () => import('../views/CookiesView.vue')
    }
  ],
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
